<style>

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  /* padding: 20px; */
  overflow-y: scroll;
}

.margin{
  color: white;
  margin: 50px;
  text-align: center;
}
.title-signup{
  font-size: 40px;
}


.no-class {
  bottom: 110%; 
  opacity: 0;
  position: absolute;
  animation-name: none;
  animation-duration: 0;
  border-radius: 0;
  width: 0;
  height: 0;
}
  

</style>



<div class="bg">
  <div class="title-signup">Welcome To The Party</div>
  <div class="margin">Thank you.  We sincerely hope you enjoy yourself here.  If you don't please send us <a href="/feedback" use:link>feedback</a>.</div>
</div>

<!-- <div class="adrop"></div> -->


<div class="next">
  <button on:click="{next}">Let's Get Started!</button>
</div>


<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';


import { onMount } from "svelte";
onMount(async () => {
  confettiInit();
});

import { onDestroy } from 'svelte';
onDestroy(async () => {
  confettiDelete();
});



let confettiCount = 150;
let confettiDivs = [];
let confettiCurDiv = 0;
let confettiTransitionEvent = whichAnimationEvent();
let confettiHandler = null;

function whichAnimationEvent() {
  let t, el = document.createElement("fakeelement");

  let animations = {
    "animation" : "animationend",
    "OAnimation" : "oAnimationEnd",
    "MozAnimation" : "animationend",
    "WebkitAnimation" : "webkitAnimationEnd",
  }

  for (let t in animations) {
    if (el.style[t] !== undefined) {
      return animations[t];
    }
  }
}


function confettiInit() {
	for (let t = 0; t < confettiCount; t++) {
		let div = document.createElement('div');
		
		div.className = "no-class";
		
		document.body.appendChild(div);
		confettiDivs.push(div);
	}
	
	setTimeout( confettiLoop, 0 );
}


function confettiDelete() {
  clearTimeout(confettiHandler);
  for (let i in confettiDivs) {
    document.body.removeChild(confettiDivs[i]);
  }
}


function confettiLoop() {
	
	confettiDivs[ confettiCurDiv ].style.left = (Math.ceil( Math.random()*95 ) )+"%";
	
	let size = Math.round( Math.random() );
  if (size == 1) {
    confettiDivs[ confettiCurDiv ].style.width = "10px";
  	confettiDivs[ confettiCurDiv ].style.height = "3px";
  } else {
  	confettiDivs[ confettiCurDiv ].style.width = "7px";
  	confettiDivs[ confettiCurDiv ].style.height = "2px";
  }
	
  let r =  Math.ceil( Math.random()*100 ) + 155;
  let g =  Math.ceil( Math.random()*100 ) + 155;
  let b =  Math.ceil( Math.random()*100 ) + 155;
  
  let colorString = "rgb("+r+","+g+","+b+")";
	
  let drop = Math.round( Math.random() );
	confettiDivs[ confettiCurDiv ].style.backgroundColor = colorString;
	confettiDivs[ confettiCurDiv ].className = "adrop"+drop;
	confettiDivs[ confettiCurDiv ].addEventListener(confettiTransitionEvent, endOfTransition);
	
	if (confettiCurDiv < confettiCount-1) {
		confettiCurDiv++;
	} else {
		confettiCurDiv = 0;
	}
	
	confettiHandler = setTimeout( confettiLoop, 150 );
}


function endOfTransition(e) {
	e.target.className = "no-class";
}

function next() {
  push("/events");
}


</script>